const rules = [
  {
    description: 'Extreme long-term toxicity',
    matcher: {
      hazards: ['H340', 'H350', 'H360', 'H370'],
    },
    volumes: [
      {
        lessThan: 0.05,
        score: 2,
      },
      {
        lessThan: 0.5,
        score: 3,
      },
      {
        lessThan: 1,
        score: 6,
      },
      {
        lessThan: +Infinity,
        score: 10,
      },
    ],
  },
  {
    description: 'High long-term toxicity',
    matcher: {
      hazards: ['H341', 'H351', 'H361', 'H371', 'H372', 'H373'],
    },
    volumes: [
      {
        lessThan: 0.05,
        score: 1,
      },
      {
        lessThan: 0.5,
        score: 2,
      },
      {
        lessThan: 1,
        score: 4,
      },
      {
        lessThan: +Infinity,
        score: 8,
      },
    ],
  },
  {
    description: 'No known long-term toxicity',
    matcher: {},
    volumes: [
      {
        lessThan: +Infinity,
        score: 0,
      },
    ],
  },
];

export function appendLongTermToxicity(reagents, report, options = {}) {
  const { logger } = options;
  // what is the worse hazard ?
  for (const rule of rules) {
    for (const reagent of reagents) {
      if (reagent.safety.longTermToxicity) continue;

      const matching = isMatching(reagent, rule);
      if (!matching) continue;
      reagent.safety.longTermToxicity = {
        description: rule.description,
        matchingHazards: matching.matchingHazards || [],
        score: rule.volumes.find(
          (volume) => reagent.volume.value <= volume.lessThan,
        ).score,
      };
    }
  }
  logger?.info('LongTermToxicity: Taking the highest score.');
  report.scores.longTermToxicity = Math.max(
    ...reagents.map((reagent) => reagent.safety.longTermToxicity.score),
  );
}

function isMatching(reagent, rule) {
  if (!rule.matcher.hazards) return true;
  const matchingHazards = rule.matcher.hazards.filter((hazard) =>
    reagent.hazards.includes(hazard),
  );
  if (matchingHazards.length === 0) return false;
  return {
    matchingHazards,
  };
}
